var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiveDeeperImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 313,
    height: 224,
    viewBox: "0 0 313 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.669 137.794C139.617 134.471 136.966 132.267 133.661 132.577C133.058 132.629 132.473 132.801 131.888 132.904C130.407 129.255 128.117 128.256 123.917 129.392C122.333 126.707 120.078 125.708 116.583 126.586C116.583 126.173 116.583 125.829 116.583 125.484C116.583 123.229 116.704 120.957 116.497 118.719C116.118 114.587 112.055 112.9 108.681 114.432C106.598 115.379 105.686 117.186 105.703 119.459C105.703 124.933 105.617 130.408 105.754 135.865C105.806 137.811 105.221 138.964 103.637 140.083C99.2297 143.199 98.5583 148.829 101.933 153.029C103.809 155.371 105.634 157.746 107.631 160.002C108.853 161.379 109.559 162.791 109.266 164.65C109.215 165.011 109.249 165.39 109.266 165.769C109.387 168.059 110.954 169.711 113.243 169.728C119.492 169.78 125.725 169.78 131.974 169.728C134.315 169.711 135.916 168.007 136.002 165.648C136.037 164.77 135.951 163.892 136.037 163.014C136.088 162.515 136.226 161.964 136.501 161.568C138.361 158.883 139.549 155.939 139.635 152.668C139.755 147.71 139.772 142.734 139.686 137.776L139.669 137.794ZM136.415 152.616C136.364 155.336 135.365 157.815 133.661 159.967C133.058 160.742 132.731 161.517 132.783 162.515C132.835 163.462 132.8 164.426 132.783 165.39C132.783 166.251 132.49 166.578 131.647 166.578C125.621 166.578 119.579 166.578 113.553 166.578C112.692 166.578 112.434 166.285 112.417 165.39C112.417 164.306 112.382 163.204 112.417 162.119C112.451 161.258 112.159 160.587 111.625 159.95C109.18 156.954 106.736 153.942 104.326 150.895C102.26 148.295 102.604 145.076 105.1 142.941C105.221 142.838 105.358 142.769 105.668 142.562C105.668 143.75 105.668 144.749 105.668 145.747C105.668 146.126 105.668 146.487 105.686 146.866C105.772 147.796 106.357 148.398 107.183 148.45C107.958 148.502 108.664 147.882 108.819 147.004C108.87 146.694 108.87 146.367 108.87 146.057C108.87 137.208 108.87 128.359 108.87 119.528C108.87 117.806 109.835 116.928 111.47 117.1C112.503 117.204 113.226 117.927 113.346 118.96C113.381 119.27 113.364 119.597 113.364 119.907C113.364 126.948 113.364 133.989 113.364 141.03C113.364 141.409 113.364 141.77 113.433 142.132C113.57 142.889 114.224 143.406 114.948 143.406C115.671 143.406 116.325 142.889 116.48 142.132C116.549 141.822 116.549 141.495 116.549 141.185C116.549 138.052 116.549 134.919 116.549 131.785C116.549 130.288 117.444 129.41 118.855 129.444C120.198 129.478 121.025 130.339 121.025 131.768C121.025 134.901 121.025 138.035 121.025 141.168C121.025 141.512 121.025 141.856 121.111 142.201C121.266 142.907 121.92 143.406 122.608 143.406C123.314 143.406 123.951 142.941 124.123 142.235C124.21 141.908 124.21 141.547 124.21 141.202C124.21 138.861 124.21 136.52 124.21 134.195C124.21 133.076 124.915 132.302 125.931 132.112C127.136 131.906 128.186 132.405 128.531 133.421C128.651 133.782 128.686 134.195 128.686 134.591C128.686 136.847 128.686 139.102 128.703 141.357C128.703 141.788 128.772 142.287 128.978 142.648C129.34 143.285 129.977 143.526 130.7 143.32C131.457 143.096 131.836 142.545 131.87 141.788C131.905 140.479 131.87 139.188 131.888 137.88C131.888 136.984 132.266 136.261 133.127 135.917C133.988 135.573 134.918 135.521 135.589 136.227C135.985 136.64 136.347 137.311 136.347 137.88C136.398 142.786 136.433 147.71 136.329 152.616H136.415Z",
    fill: "url(#paint0_linear_1_330)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.975 112.16C121.196 109.956 123.434 107.752 125.637 105.514C125.947 105.187 126.119 104.722 126.446 104.171C126.068 103.707 125.792 103.173 125.362 102.863C124.742 102.433 124.053 102.639 123.537 103.139C121.23 105.411 118.94 107.718 116.685 110.025C116.014 110.713 116.083 111.643 116.702 112.246C117.339 112.865 118.286 112.848 118.975 112.16Z",
    fill: "url(#paint1_linear_1_330)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6313 105.927C98.6111 107.89 100.574 109.853 102.553 111.815C102.777 112.039 103.001 112.366 103.277 112.418C103.81 112.521 104.447 112.607 104.912 112.418C105.308 112.246 105.515 111.643 105.842 111.195C105.549 110.662 105.394 110.18 105.084 109.87C102.898 107.632 100.677 105.411 98.439 103.225C97.7159 102.502 96.8207 102.502 96.1493 103.104C95.5295 103.672 95.5123 104.654 96.1321 105.411C96.287 105.6 96.4592 105.755 96.6313 105.927Z",
    fill: "url(#paint2_linear_1_330)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.901 110.92C111.882 110.937 112.519 110.231 112.536 109.078C112.536 107.546 112.536 105.996 112.536 104.464C112.536 102.932 112.536 101.383 112.536 99.8504C112.536 98.7486 111.917 98.0427 110.987 98.0083C110.023 97.9911 109.352 98.7141 109.352 99.8504C109.352 102.932 109.352 105.996 109.352 109.078C109.352 110.18 109.971 110.903 110.901 110.92Z",
    fill: "url(#paint3_linear_1_330)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.121 116.79C103.121 115.826 102.415 115.172 101.261 115.172C98.1798 115.172 95.1154 115.172 92.0338 115.172C90.9148 115.172 90.2262 115.792 90.209 116.739C90.209 117.72 90.8976 118.34 92.0683 118.357C93.6005 118.357 95.1499 118.357 96.682 118.357C98.197 118.357 99.712 118.357 101.21 118.357C102.398 118.357 103.086 117.772 103.103 116.79H103.121Z",
    fill: "url(#paint4_linear_1_330)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.612 115.172C119.459 115.172 118.753 115.809 118.77 116.79C118.787 117.737 119.476 118.34 120.595 118.357C122.127 118.357 123.676 118.357 125.209 118.357C126.741 118.357 128.29 118.357 129.822 118.357C130.976 118.357 131.682 117.72 131.664 116.739C131.647 115.792 130.941 115.172 129.84 115.172C126.758 115.172 123.694 115.172 120.612 115.172Z",
    fill: "url(#paint5_linear_1_330)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M399.195 36.2904H112.022C97.2177 36.2904 85.2169 48.2875 85.2169 63.0865C85.2169 77.8856 97.2177 89.8825 112.022 89.8825H399.195C413.998 89.8825 425.999 77.8856 425.999 63.0865C425.999 48.2875 413.998 36.2904 399.195 36.2904Z",
    stroke: "url(#paint6_linear_1_330)",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.554 75.6108L128.912 68.7074C128.137 68.0876 127.173 67.881 126.278 68.036C127.672 65.9357 128.481 63.4222 128.481 60.7194C128.481 53.3855 122.525 47.4289 115.191 47.4289C107.857 47.4289 101.9 53.3855 101.9 60.7194C101.9 68.0532 107.857 74.0098 115.191 74.0098C118.324 74.0098 121.199 72.908 123.472 71.1003C123.472 71.3069 123.472 71.5135 123.472 71.7201C123.575 72.6153 124.005 73.4072 124.711 73.9753L133.353 80.8788C133.956 81.3608 134.679 81.6191 135.436 81.6191C135.557 81.6191 135.695 81.6191 135.815 81.6018C136.71 81.4986 137.502 81.0682 138.07 80.3623C139.224 78.9162 138.983 76.7987 137.537 75.6453L137.554 75.6108ZM103.45 60.7021C103.45 54.2291 108.718 48.9611 115.191 48.9611C121.664 48.9611 126.932 54.2291 126.932 60.7021C126.932 67.1752 121.664 72.4432 115.191 72.4432C108.718 72.4432 103.45 67.1752 103.45 60.7021ZM136.865 79.3638C136.573 79.7426 136.142 79.9836 135.66 80.0352C135.178 80.0869 134.713 79.9492 134.335 79.6565L125.692 72.753C125.314 72.4432 125.073 72.03 125.021 71.548C124.969 71.0659 125.107 70.6011 125.4 70.2223C126.019 69.4476 127.156 69.3099 127.93 69.9469L136.573 76.8503C137.347 77.4701 137.485 78.6063 136.848 79.381L136.865 79.3638Z",
    fill: "url(#paint7_linear_1_330)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M8.5045 164.822H0V173.326H8.5045V164.822Z",
    fill: "#FF00DB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M22.2778 128.669H13.7733V137.174H22.2778V128.669Z",
    fill: "#FF00DB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M8.5045 176.167H0V184.672H8.5045V176.167Z",
    fill: "#2C75E4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M21.7408 176.167H13.2363V184.672H21.7408V176.167Z",
    fill: "#2C75E4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M34.983 176.167H26.4785V184.672H34.983V176.167Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M48.2408 176.167H39.7363V184.672H48.2408V176.167Z",
    fill: "#FF00DB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M48.2408 43.6071H39.7363V52.1116H48.2408V43.6071Z",
    fill: "#FF00DB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M125.708 0.568115H117.203V9.07262H125.708V0.568115Z",
    fill: "#FF00DB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M61.4772 176.167H52.9727V184.672H61.4772V176.167Z",
    fill: "#003332"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M34.0357 163.875H25.5312V172.38H34.0357V163.875Z",
    stroke: "#FFF8FF",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M21.7408 86.3189H13.2363V94.8234H21.7408V86.3189Z",
    fill: "#FF00DB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M34.0357 74.027H25.5312V82.5315H34.0357V74.027Z",
    fill: "#003332"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M182.09 0H173.586V8.5045H182.09V0Z",
    fill: "#003332"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M113.227 0H104.723V8.5045H113.227V0Z",
    fill: "#003332"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M10.3971 86.3189H1.89258V94.8234H10.3971V86.3189Z",
    fill: "#2C75E4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M47.2896 163.875H38.7852V172.38H47.2896V163.875Z",
    fill: "#003332"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M33.5162 144.938H25.0117V153.442H33.5162V144.938Z",
    fill: "#003332"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M21.4652 103.621H12.9607V112.125H21.4652V103.621Z",
    fill: "#003332"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M72.8209 163.875H64.3164V172.38H72.8209V163.875Z",
    fill: "#2C75E4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M124.848 202.662H116.344V211.166H124.848V202.662Z",
    fill: "#003332"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M138.087 202.662H129.582V211.166H138.087V202.662Z",
    fill: "#FF00DB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M21.7408 189.423H13.2363V197.928H21.7408V189.423Z",
    fill: "#003332"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M47.2896 189.423H38.7852V197.928H47.2896V189.423Z",
    stroke: "#FF00FF",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M34.5181 86.7837H26.0136V95.2882H34.5181V86.7837Z",
    stroke: "#FFF8FF",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M75.8346 85.0622H67.3301V93.5667H75.8346V85.0622Z",
    stroke: "#FFF8FF",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M167.077 0.705841H158.572V9.21033H167.077V0.705841Z",
    stroke: "#013836",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M74.112 176.305H65.6075V184.809H74.112V176.305Z",
    stroke: "#FF00FF",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M75.8346 97.1131H67.3301V105.618H75.8346V97.1131Z",
    stroke: "#FF00FF",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M153.303 0.705841H144.799V9.21033H153.303V0.705841Z",
    stroke: "#FF00FF",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M21.2779 74.4918H12.7734V82.9963H21.2779V74.4918Z",
    stroke: "#2C75E4",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M10.86 61.253H2.35547V69.7575H10.86V61.253Z",
    stroke: "#2C75E4",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M34.5181 61.253H26.0136V69.7575H34.5181V61.253Z",
    stroke: "#2C75E4",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M34.5181 44.0374H26.0136V52.5419H34.5181V44.0374Z",
    stroke: "#2C75E4",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M60.0455 61.253H51.541V69.7575H60.0455V61.253Z",
    stroke: "#2C75E4",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M75.5397 73.3039H67.0352V81.8084H75.5397V73.3039Z",
    stroke: "#2C75E4",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M75.5397 61.253H67.0352V69.7575H75.5397V61.253Z",
    stroke: "#2C75E4",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M139.237 0.998505H130.733V9.50301H139.237V0.998505Z",
    stroke: "#013836",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M60.9948 189.888H52.4903V198.392H60.9948V189.888Z",
    stroke: "#013836",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M33.4498 127.912H24.9453V136.416H33.4498V127.912Z",
    stroke: "#013836",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M73.3033 215.436H64.7988V223.94H73.3033V215.436Z",
    stroke: "#FF00FF",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M86.5436 215.436H78.0391V223.94H86.5436V215.436Z",
    stroke: "#2C75E4",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M73.3033 202.18H64.7988V210.684H73.3033V202.18Z",
    stroke: "#2C75E4",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M112.075 202.18H103.57V210.684H112.075V202.18Z",
    stroke: "#2C75E4",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M99.7799 215.436H91.2754V223.94H99.7799V215.436Z",
    stroke: "#013836",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M113.022 215.436H104.517V223.94H113.022V215.436Z",
    stroke: "#2C75E4",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M126.262 215.436H117.758V223.94H126.262V215.436Z",
    stroke: "#2C75E4",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M139.499 215.436H130.994V223.94H139.499V215.436Z",
    stroke: "#2C75E4",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_330",
    x1: 99.7978,
    y1: 141.822,
    x2: 139.721,
    y2: 141.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_330",
    x1: 116.186,
    y1: 107.666,
    x2: 126.429,
    y2: 107.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_330",
    x1: 95.6845,
    y1: 107.597,
    x2: 105.842,
    y2: 107.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_330",
    x1: 109.352,
    y1: 104.481,
    x2: 112.536,
    y2: 104.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_330",
    x1: 90.2262,
    y1: 116.756,
    x2: 103.121,
    y2: 116.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_330",
    x1: 118.77,
    y1: 116.756,
    x2: 131.664,
    y2: 116.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_330",
    x1: 219.912,
    y1: 143.285,
    x2: 291.322,
    y2: -17.1123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B086CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9F79C8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_330",
    x1: 116.964,
    y1: 76.0412,
    x2: 127.775,
    y2: 51.7673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiveDeeperImg);
export default __webpack_public_path__ + "static/media/DiveDeeperImg.13d99c3eaffc025a8209bac5828fd745.svg";
export { ForwardRef as ReactComponent };